export var defaultQueryConfig = {
  staleTime: 30000,
  placeholderData: {
    data: {
      data: [],
      meta: {}
    }
  }
};
//# sourceMappingURL=config.js.map